<div class="task-rich-text-editor" [class.task-rich-text-editor--disabled]="disabled()">
  <div class="task-rich-text-editor__toolbar">
    <button type="button" class="task-rich-text-editor__tool" (click)="applyCommand('bold')" [disabled]="disabled()" matTooltip="Bold">
      <mat-icon aria-hidden="true">format_bold</mat-icon>
    </button>
    <button type="button" class="task-rich-text-editor__tool" (click)="applyCommand('italic')" [disabled]="disabled()" matTooltip="Italic">
      <mat-icon aria-hidden="true">format_italic</mat-icon>
    </button>
    <button type="button" class="task-rich-text-editor__tool" (click)="applyCommand('insertUnorderedList')" [disabled]="disabled()" matTooltip="Bulleted list">
      <mat-icon aria-hidden="true">format_list_bulleted</mat-icon>
    </button>
    <button type="button" class="task-rich-text-editor__tool" (click)="applyCommand('insertOrderedList')" [disabled]="disabled()" matTooltip="Numbered list">
      <mat-icon aria-hidden="true">format_list_numbered</mat-icon>
    </button>
    <button type="button" class="task-rich-text-editor__tool" (click)="addLink()" [disabled]="disabled()" matTooltip="Add link">
      <mat-icon aria-hidden="true">link</mat-icon>
    </button>
    <button type="button" class="task-rich-text-editor__tool" (click)="clearFormatting()" [disabled]="disabled()" matTooltip="Clear formatting">
      <mat-icon aria-hidden="true">format_clear</mat-icon>
    </button>
  </div>

  <div
    #editorRef
    class="task-rich-text-editor__surface"
    [attr.contenteditable]="!disabled()"
    [attr.data-placeholder]="placeholder()"
    (input)="onInput($event)"
    (blur)="onBlur()"
  ></div>
</div>
